import api from '@/services/Api'

export default {
    queryByPaymentIntent (paimentIntentId) {
        return api().get(`/stripe/refunds/queryByPaymentIntent/${paimentIntentId}`)
    },
}
